module.exports = [{"url":"nelly-toncheva","name":"Nelly Toncheva","position":"Sales Director","email":"nelly.toncheva@alcomet.eu","phone":"+35954858615","foreignLanguages":"English","img":"/static/img/contacts/sales_department/nely-toncheva.jpg"}]


//////////////////
// WEBPACK FOOTER
// ./src/components/contacts/MainSalesDepartment.json
// module id = 98Or
// module chunks = 1